module.exports = __webpack_public_path__ + "img/poker-s11.c989b59d.svg";